export default __webpack_public_path__ + "static/media/ValuMass-500-Inline.202c610f.png";